import styled from 'styled-components';

interface HeaderProps {
  justifyContent?: string;
  alignItems?: string;
  marginBottom?: string;
  padding?: string;
}

export const Header = styled.div<HeaderProps>`
  display: flex;
  justify-content: ${props => props.justifyContent || 'space-between'};
  align-items: ${props => props.alignItems || 'center'};
  margin-bottom: ${props => props.marginBottom || '2rem'};
  padding: ${props => props.padding || '0'};
`;